"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XEvent = void 0;
class XEvent {
    static get Ins() {
        if (!this._Inst) {
            this._Inst = new XEvent();
        }
        return this._Inst;
    }
    constructor() {
        this._listeners = {};
    }
    On(event, listener) {
        if (!this._listeners[event]) {
            this._listeners[event] = [];
        }
        this._listeners[event].push(listener);
    }
    Once(event, listener) {
        if (!this._listeners[event]) {
            this._listeners[event] = [];
        }
        this._listeners[event].push(listener);
    }
    off(event, listener) {
        if (!this._listeners[event]) {
            return;
        }
        const index = this._listeners[event].indexOf(listener);
        if (index > -1) {
            this._listeners[event].splice(index, 1);
        }
    }
    emit(event, data) {
        if (!this._listeners[event]) {
            return;
        }
        this._listeners[event].forEach(listener => listener(data));
    }
    async emitSync(event, data) {
        if (!this._listeners[event]) {
            return;
        }
        for (let listener of this._listeners[event]) {
            await listener(data);
        }
    }
}
exports.XEvent = XEvent;
;
window.XEvent = XEvent;
